<div class="title">Ticket Generated Successfully</div>
<div class="information">
  <span>The ticket has been generated</span>
  <span>reference Id is {{data.refId}}</span>
</div>

<div class="actions">
  <button mat-raised-button color="primary" class="viewBtn" (click)="onView(data.refId)">View</button>
  <button mat-flat-button class="close-button" mat-dialog-close>Close</button>
</div>